angular.module('erp.other.clickShopOpeningDetail').run(['$templateCache', function($templateCache) {
  $templateCache.put("tpl/outbox.htm",
    "<div class=\"clickShopOpeningDetail-css\">\n" +
    "</div>\n" +
    "");
}]);
